export const DBApplicationMapper = (data) => {
  let _application = {
    /*company details*/
    applicationId: data?.APPLICATION_ID,
    status: data?.STATUS,
    websiteLink: data?.WEBSITE,
    physicalAddress: data?.PHYSICAL_ADDRESS,
    postalAddress: data?.POSTAL_ADDRESS,
    contactPhone: data?.CONTACT_PERSON_PHONE,
    contactEmail: data?.CONTACT_PERSON_EMAIL,
    incorporationNumber: data?.INCORPORATION_NUMBER,
    contactPerson: data?.CONTACT_PERSON_NAME,
    companyName: data?.COMPANY_NAME,
    /*solution summary*/
    solutionId: data?.SOLUTION_ID,
    solutionName: data?.SOLUTION_NAME,
    natureOfOperation: data.NATURE_OF_OPERATION,
    scaleOfOperation: data?.SCALE,
    marketOfOperation: data?.MARKET ? JSON.parse(data?.MARKET) : null,
    solutionAttribute: data?.ATTRIBUTE,
    testingPeriod: data?.TESTING_PERIOD,
    deploymentDuration: data?.TIME_TO_DEPLOY,
    technologiesUsed: data?.TECHNOLOGY_USED
      ? JSON.parse(data?.TECHNOLOGY_USED)
      : null,
    sourceOfFunds: data?.SOURCE_OF_FUND
      ? JSON.parse(data?.SOURCE_OF_FUND)
      : null,
    solutionObjectives: data?.OBJECTIVE ? JSON.parse(data?.OBJECTIVE) : null,
    /*solution details*/
    problemDescription: data?.PROBLEM_DESCRIPTION,
    solutionDescription: data?.SOLUTION_DESCRIPTION,
    legalChallenges: data?.LEGAL_CHALLENGES,
    specialExemptions: data?.REGULATORY_EXEMPTIONS,
    /* arrays */
    shareholders: [],
    directors: [],
    risks: [],
    attachments: [...data?.ATTACHMENTS],
    reportDates: [...data?.REPORT_DATES],
  };

  //Add shareholders
  const _shareholders = data?.STAKEHOLDERS?.filter((x) => x?.TYPE === "S");

  for (let i = 0; i < (_shareholders || []).length; i++) {
    const row = _shareholders[i];
    _application.shareholders.push({
      id: row?.STAKEHOLDER_ID,
      name: row?.FULL_NAME,
      nationality: row?.NATIONALITY,
      phone: row?.PHONE_NUMBER,
      email: row?.EMAIL,
      occupation: row?.OCCUPATION,
      shares: row?.SHARES_HELD,
    });
  }

  //Add directors
  const _directors = data?.STAKEHOLDERS?.filter((x) => x?.TYPE === "D");
  for (let i = 0; i < (_directors || []).length; i++) {
    const row = _directors[i];
    _application.directors.push({
      id: row?.STAKEHOLDER_ID,
      name: row?.FULL_NAME,
      nationality: row?.NATIONALITY,
      phone: row?.PHONE_NUMBER,
      email: row?.EMAIL,
      designation: row?.DESIGNATION,
      educationQualification: row?.EDUCATION,
    });
  }

  //Add risks
  for (let i = 0; i < (data?.RISKS || []).length; i++) {
    const row = data?.RISKS[i];
    _application.risks.push({
      id: row?.RISK_ID,
      risk: row?.RISK,
      mitigationMeasure: row?.MEASURE,
    });
  }
  // console.log("*********", _application);
  return _application;
};
